import { Form } from "@circle-react-shared/uikit/Form";

interface DefaultsFormItemProps {
  [key: string]: unknown;
  children: React.ReactNode;
  name: string;
  rules?: Record<string, unknown>;
  tooltip?: string;
}

const i18nRoot = "landing_page.settings";

export const DefaultsFormItem = ({
  children,
  name,
  rules = {},
  tooltip,
  ...props
}: DefaultsFormItemProps) => (
  <div className="-mt-1">
    <Form.Item
      name={name}
      hideDescription
      translationRoot={i18nRoot}
      rules={rules}
      variant="extra-bottom-margin"
      hideBorder
      fullWidth
      hidePlaceholder
      tooltipText={tooltip}
      {...props}
    >
      {children}
    </Form.Item>
  </div>
);
